import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import Icon from "../../common/icons";
import { maskEmail } from "./registerRules";
import "./register.css";

/**
 * After sign-up (F18): a big card that stays until the student closes it, instead of a toast
 * that disappears. It names the inbox to check, offers a sign-in code (common/SignInCodeFlow
 * through the sign-in dialog) and a way back when the email was typed wrong. When the welcome
 * email couldn't go out (views.register said email_sent: false), it says so and leads with the code.
 */
const RegisterInbox = ({ email, emailSent = true, onCode, onWrongEmail }) => {
  const reduce = useReducedMotion();
  const masked = maskEmail(email);

  return (
    <motion.div
      className="rg-inbox"
      initial={reduce ? false : { opacity: 0, y: 14, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className={`rg-inbox-card${emailSent ? "" : " is-warn"}`} role="status">
        <motion.span
          className="rg-inbox-tile"
          initial={reduce ? false : { scale: 0.5, rotate: -10 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 380, damping: 16, delay: 0.08 }}
        >
          <Icon name={emailSent ? "mail-check" : "alert-triangle"} size={30} />
        </motion.span>
        {emailSent ? (
          <>
            <h3 className="rg-inbox-title">Check your inbox at {masked}</h3>
            <p className="rg-inbox-text">
              Open the email from Anna and tap the link to set your password. It can take a few minutes.
            </p>
          </>
        ) : (
          <>
            <h3 className="rg-inbox-title">Your account is ready, but the email didn’t go out</h3>
            <p className="rg-inbox-text">
              We couldn’t send the email to {masked}. Get a sign-in code instead, and you’re in.
            </p>
          </>
        )}
      </div>

      <button type="button" className="am-btn is-primary is-block is-large" onClick={onCode}>
        <Icon name="key" size={18} />
        Email me a sign-in code
      </button>
      <button type="button" className="am-link rg-inbox-wrong" onClick={onWrongEmail}>
        Wrong email?
      </button>
    </motion.div>
  );
};

export default RegisterInbox;
